import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts';

export default function ProgressRing({ data, size = 100 }) {
  return (
    <div style={{ width: size, height: size }}>
      <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart cx="50%" cy="50%" innerRadius="30%" outerRadius="100%" data={data} startAngle={90} endAngle={-270}>
          <RadialBar dataKey="value" cornerRadius={4} background={{ fill: 'rgba(255,255,255,0.04)' }} />
        </RadialBarChart>
      </ResponsiveContainer>
    </div>
  );
}
